import runtime from '../src/runtime/locales/zh-CN';
import renderer from '../src/renderer/locales/zh-CN';
export default {
    runtime,
    renderer
};
